import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContributorAccountDetail } from './contributor-account-detail.model';

export type { ContributorAccountDetail } from './contributor-account-detail.model';

@Component({
  selector: 'app-contributor-account-details',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './contributor-account-details.component.html',
  styleUrl: './contributor-account-details.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContributorAccountDetailsComponent {
  @Input() data!: ContributorAccountDetail;

  get formattedAccountNo(): string {
    return this.data.accountNo?.replace('\\', ' / ') ?? '';
  }

  get accountNoParts(): [string, string] {
    const parts = this.formattedAccountNo.split(' / ');
    return [parts[0] ?? '', parts[1] ?? ''];
  }

  isMuted(value: string): boolean {
    return value === '0.00';
  }

  /** Returns [whole, cents] — e.g. '2,252,799.32' → ['2,252,799', '.32'] */
  splitAmount(value: string): [string, string] {
    if (!value) return ['0', '.00'];
    const idx = value.lastIndexOf('.');
    if (idx === -1) return [value, ''];
    return [value.slice(0, idx), value.slice(idx)];
  }
}
